
import { Vue, Component } from 'vue-property-decorator';
import Api from '@/services/api';
import FileHelper from '@/helpers/file-helper';

@Component
export default class Merchant extends Vue {
  public formTitle = 'مدیریت سیم کارت های گروه';
  public desserts = [];
  public chargeProducts = [];
  public packageProducts = [];
  public dialog = false;
  public editDialog = false;
  public chargeDialog = false;
  public totalRowsCount = 0;
  public pageIndex = 1;
  public totalPageCount = 0;
  public pageSize = 25;
  public phoneNumber = '';

  public headers = [
    { text: 'نام', value: 'name' },
    { text: 'شماره تلفن', value: 'phoneNumber' },
    { text: 'نام شرکت', value: 'company' },
    { text: 'مانده شارژ', value: 'chargePrice' },
    { text: 'مانده بسته', value: 'packageCapacity' },
    { text: 'عملیات', value: 'action', sortable: false }
  ];
  public group = {
    id: 0,
    name: '',
    company: '',
    walletLimit: 0,
    chargeLimit: 0,
    packageLimit: 0,
    chargeProductId: 0,
    packageProductId: 0,
    phoneNotifyStatus: '',
    emailNotifyStatus: '',
    chargeAutoStatus: '',
    packageAutoStatus: '',
    phoneNotify: true,
    emailNotify: true,
    chargeAuto: true,
    packageAuto: true,
    credit: 0,
    isDisabled: '',
    checkMode: 0,
    checkModeTitle: '',
    checkTime: null as string | null,
    checkDayOfWeek: null as number | null,
    checkDayOfMonth: null as number | null,
    lastRunAt: null as string | null,
    nextRunAt: null as string | null,
  };
  public groupDefault = {
    id: 0,
    name: '',
    company: '',
    walletLimit: 0,
    chargeLimit: 0,
    packageLimit: 0,
    chargeProductId: 0,
    packageProductId: 0,
    phoneNotifyStatus: '',
    emailNotifyStatus: '',
    chargeAutoStatus: '',
    packageAutoStatus: '',
    phoneNotify: true,
    emailNotify: true,
    chargeAuto: true,
    packageAuto: true,
    credit: 0,
    isDisabled: '',
    checkMode: 0,
    checkModeTitle: '',
    checkTime: null as string | null,
    checkDayOfWeek: null as number | null,
    checkDayOfMonth: null as number | null,
    lastRunAt: null as string | null,
    nextRunAt: null as string | null,
  };
  public editedItem = {
    id: 0,
    sim: ''
  };
  public defaultItem = {
    id: 0,
    sim: ''
  };
  public chargeItem = {
    id: 0,
    amount: 0
  };

  public breadcrumbItems = [
    {
      text: 'صفحه اصلی',
      disabled: false,
      href: '/'
    },
    {
      text: 'مدیریت گروه',
      disabled: false,
      href: '/group/manage'
    },
    {
      text: 'مدیریت سیم کارت های گروه',
      disabled: true,
      href: ''
    }
  ];

  public checkModes = [
    { text: 'مداوم', value: 0 },
    { text: 'روزانه', value: 1 },
    { text: 'هفتگی', value: 2 },
    { text: 'ماهانه', value: 3 }
  ];
  public weekDays = [
    { text: 'شنبه', value: 0 },
    { text: 'یکشنبه', value: 1 },
    { text: 'دوشنبه', value: 2 },
    { text: 'سه‌شنبه', value: 3 },
    { text: 'چهارشنبه', value: 4 },
    { text: 'پنجشنبه', value: 5 },
    { text: 'جمعه', value: 6 },
  ];
  public monthDays = [
    { text: 'آخر ماه', value: 0 },
    ...Array.from({ length: 31 }, (_, i) => ({ text: `${i + 1}`, value: i + 1 }))
  ];

  onCheckModeChange() {
    if (this.group.checkMode != 2) this.group.checkDayOfWeek = null;
    if (this.group.checkMode != 3) this.group.checkDayOfMonth = null;
    if (this.group.checkMode == 0) this.group.checkTime = null;
  }

  async created() {
    this.$showLoading();
    await Api.getProducts(1).then((response: any) => {
      this.chargeProducts = response.data;
    });

    await Api.getProducts(2).then((response: any) => {
      this.packageProducts = response.data;
      this.$hideLoading();
    });

    await this.initialize();
  }

  async initialize() {
    this.$showLoading();
    await Api.getGroup(parseInt(this.$route.params.id)).then((response: any) => {
      this.group = response.data;
      if (this.group.checkTime) this.group.checkTime = this.group.checkTime.substring(0, 5);
    });
    await this.getData();
  }

  async getData() {
    this.$showLoading();
    await Api.getGroupItems({
      groupId: parseInt(this.$route.params.id),
      phoneNumber: this.phoneNumber,
      pageIndex: this.pageIndex - 1,
      pageSize: this.pageSize
    }).then((response: any) => {
      this.desserts = response.data.data;
      this.totalRowsCount = response.data.totalRowsCount;
      this.totalPageCount = Math.ceil(this.totalRowsCount / this.pageSize);
      this.$hideLoading();
    });
  }

  async chargeGroupConfirm() {
    this.$showLoading();
    await Api.chargeGroup(parseInt(this.$route.params.id), this.chargeItem.amount).then((response: any) => {
      this.$showNotification('success', 'شارژ با موفقیت ثبت شد');
      this.close();
      this.$hideLoading();
    });
  }

  async save() {
    const isValid = (this.$refs.Observer as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.createGroupItem(parseInt(this.$route.params.id), this.editedItem.sim).then((response: any) => {
      this.close();
      this.$showNotification('success', 'سیم کارت در گروه ثبت شد');
      this.$hideLoading();
    });
  }

  async edit(item: any) {
    this.group = Object.assign({}, item);
    this.group.id = parseInt(this.$route.params.id);
    this.editDialog = true;
  }

  async editItem() {
    const isValid = (this.$refs.Observer2 as any).validate();
    if (!isValid) {
      return;
    }
    this.$showLoading();
    await Api.editGroup({
      id: this.group.id,
      phoneNotify: this.group.phoneNotify,
      emailNotify: this.group.emailNotify,
      chargeAuto: this.group.chargeAuto,
      packageAuto: this.group.packageAuto,
      walletLimit: this.group.walletLimit,
      chargeLimit: this.group.chargeLimit,
      packageLimit: this.group.packageLimit,
      chargeProductId: this.group.chargeProductId,
      packageProductId: this.group.packageProductId,
      checkMode: this.group.checkMode,
      checkTime: this.group.checkTime ? this.group.checkTime.substring(0, 5) + ':00' : null,
      checkDayOfWeek: this.group.checkDayOfWeek,
      checkDayOfMonth: this.group.checkDayOfMonth
    }).then((response: any) => {
      this.close();
      this.$showNotification('success', 'درخواست با موفقیت ثبت شد');
      this.$hideLoading();
    });
  }

  async updateCredit(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید این مورد را بروز کنید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.updateCredit(id).then((response: any) => {
        this.$showNotification('success', 'سیم کارت بروز شد');
        this.close();
        this.$hideLoading();
      });
    }
  }

  async deleteItem(id: number) {
    const confirmed = await this.$showConfirm('هشدار', 'آیا مطمئن هستید که می خواهید این مورد را حذف کنید؟');
    if (confirmed) {
      this.$showLoading();
      await Api.deleteGroupItem(id).then((response: any) => {
        this.close();
        this.$hideLoading();
      });
    }
  }

  async close() {
    this.dialog = false;
    this.editDialog = false;
    this.chargeDialog = false;
    this.phoneNumber = '';
    this.$nextTick(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.group = Object.assign({}, this.groupDefault);
    });
    this.initialize();
  }

  async download() {
    this.$showLoading();
    const downloadResponse = await Api.getGroupItemDownload({
      groupId: parseInt(this.$route.params.id)
    });
    FileHelper.downloadFile(downloadResponse);

    this.$hideLoading();
  }

  formatPrice(value: number) {
    const val = (value / 1).toFixed(0).replace('.', ',');
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  getColor(isDisabled: string) {
    if (isDisabled === 'فعال') {
      return 'green lighten-2';
    } else {
      return 'red lighten-1';
    }
  }
}
